import CONSTANTS from './constants.js'
const instrumentCreator = (text) => {
    return {
        type:CONSTANTS.ACTIONS.INSTRUMENT,
        text
    };
};

export default instrumentCreator;